import { render } from "./UserProfileMenu.vue?vue&type=template&id=a6eb61c4&scoped=true"
import script from "./UserProfileMenu.vue?vue&type=script&lang=js"
export * from "./UserProfileMenu.vue?vue&type=script&lang=js"

import "./UserProfileMenu.vue?vue&type=style&index=0&id=a6eb61c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6eb61c4"]])

export default __exports__